import NAV_DATA from '@zola-helpers/client/dist/es/constants/navConstants';
import featureFlags from '../../../util/featureFlags';

import { MegaMenuNavItem } from './types';

const {
  PRIMARY: { VENDORS },
} = NAV_DATA;

const getVendors = (isInMegaMenuTest = false): MegaMenuNavItem => {
  const locationChildren = [
    {
      title: 'New York',
      path: '/wedding-vendors/search/new-york-ny--wedding-venues',
    },

    {
      title: 'Chicago',
      path: '/wedding-vendors/search/chicago-il--wedding-venues',
    },
    {
      title: 'Los Angeles',
      path: '/wedding-vendors/search/los-angeles-ca--wedding-venues',
    },
    {
      title: 'Philadelphia',
      path: '/wedding-vendors/search/philadelphia-pa--wedding-venues',
    },
    {
      title: 'See All Locations',
      path: '/wedding-vendors/search/wedding-venues',
      arrowLink: true,
    },
  ];

  const inspirationChildren = [
    {
      title: 'Get Inspired',
      path: '/inspiration',
    },
  ];

  const inspirationChildrenABTest = [
    {
      title: 'Find your wedding style',
      path:
        featureFlags.getEnvironment() === 'production'
          ? 'https://quiz.zola.com/flow/stylequiz/variant/5-4-final'
          : 'https://quiz.zola.com/flow/stylequiz/variant/5-4-final-qa',
    },
  ];

  const exploreChildren = [
    {
      title: 'Become A Vendor',
      path: '/wedding-vendors/become-a-vendor',
    },
    {
      title: 'Vendor FAQs',
      path: 'https://help.zola.com/hc/en-us/categories/360000467031-Vendor-Listings-Real-Weddings',
    },
    {
      title: 'Vendor Expert Advice',
      path: '/expert-advice/topic/planning-101/hiring-vendors',
    },
  ];

  return {
    title: 'Vendors',
    id: VENDORS,
    path: '/wedding-vendors',
    parent: 'Vendors',
    callToAction: {
      path: '/wedding-vendors',
      title: 'Browse Vendors',
      items: [
        'Exceptional vendors for every couple, all pre-screened for you',
        'Personalized recs based on your unique wedding vision',
        'Sleek, simplified experience with ad-free search results',
      ],
    },
    userActionsLinks: [
      {
        title: 'Your Vendor Inquiries',
        path: '/wedding-vendors/inquiries',
      },
      {
        title: 'Your Booked Vendors',
        path: '/wedding-vendors/inquiries/booked',
      },
    ],
    children: [
      {
        headline: 'Popular Locations',
        children: locationChildren,
        secondHeadline: 'Real Weddings',
        secondChildren: isInMegaMenuTest ? inspirationChildrenABTest : inspirationChildren,
      },
      {
        headline: 'Learn More',
        children: exploreChildren,
      },
    ],
  };
};

export default getVendors;
